import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { useEffect } from "react"
import { ReactComponent as OopsySvg } from "../../assets/errorPages/oopsy.svg"
import { Modal } from "../modal"
import { Button } from "../formElements/button"
import { useTranslation } from "next-i18next"

const Oopsy = styled(OopsySvg)(() => [tw`w-full`])

export interface ErrorModalProps {
  handleError: boolean
}

const reload = async () => {
  window.location.reload()
}

export const ErrorModalView = () => {
  const { t } = useTranslation("common")
  return (
    <div tw="flex items-center flex-col justify-center space-y-4">
      <Oopsy />
      <p>{t("500.h1")}</p>
      <Button action={t("500.button")} onClick={reload}></Button>
    </div>
  )
}

export const ErrorHandler = (props: ErrorModalProps) => {
  const { handleError } = props
  const [showModal, setShowModal] = useState(false)
  const modalProps = { show: showModal, setShow: setShowModal, component: <ErrorModalView /> }
  useEffect(() => {
    if (handleError) {
      setShowModal(true)
    }
  }, [handleError])
  return <Modal {...modalProps} />
}
